import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const text = {
  fontSize: 14,
  fontWeight: 400,
};

export default makeStyles(({ spacing }) => ({
  container: {
    gap: spacing(2),

    "& .react-colorful__saturation": {
      width: 232,
      height: 200,
      borderRadius: spacing(0.5),
    },

    "& .react-colorful__hue": {
      width: 232,
      height: 8,
      borderRadius: spacing(0.5),
    },

    "& .react-colorful__alpha": {
      display: "none !important",
    },

    "& .react-colorful__pointer": {
      width: 8,
      height: 8,
      border: "1.5px solid #ffffff",
    },
  },
  hexAdornment: {
    ...text,
    color: grey[400],
  },
  hexText: {
    ...text,
    padding: spacing(0),
    height: 32,
  },
  hexContainer: {
    width: 158,
  },
  percentAdornment: {
    ...text,
    marginLeft: spacing(0),
  },
  percentText: {
    ...text,
    textAlign: "right",
    paddingRight: spacing(0.5),
  },
  percentContainer: {
    width: 66,
  },
}));
